export default __webpack_public_path__ + "static/media/el3.642bf7d9.jpeg";